import { render } from "./SettingIcon.vue?vue&type=template&id=6dd5c580"
import script from "./SettingIcon.vue?vue&type=script&lang=js"
export * from "./SettingIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__